export default __webpack_public_path__ + "static/google-searches-ec54b5096510b5aa87bb51a301b93fba.webp";